import {
    LOADING_EMAIL_BLASTER,
    EMAIL_BLASTER_GET_EMPLOYEE_EMAILS
} from "api/menu/email-blaster/actions";

const initialState = {
    loading: false,
    employeeEmails: []
};

export default function(state = initialState, action) {
    switch (action.type) {
        case LOADING_EMAIL_BLASTER:
            return {
                ...state,
                loading: action.payload
            };
        case EMAIL_BLASTER_GET_EMPLOYEE_EMAILS:
            return {
                ...state,
                loading: false,
                employeeEmails: action.payload,
            };
        default:
            return state;
    }
}
